/**
 * @fileoverview POST handler for the "/integrations/scim/scim_edit_settings" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { integrationsScimScimEditSettingsCacheKeys } from "./constants";
import type { PostIntegrationsScimScimEditSettingsProps, IntegrationsScimScimEditSettingsResult } from "./types";

export const postIntegrationsScimScimEditSettings = reactQueryMutationAdapter(
  integrationsScimScimEditSettingsCacheKeys,
  (props: PostIntegrationsScimScimEditSettingsProps): Promise<IntegrationsScimScimEditSettingsResult> => {
    // manipulate props here as needed { idp, default_ag_id, identity_provider_company_id, ip_whitelist }

    return fetch("/integrations/scim/scim_edit_settings", "POST", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
